import { render } from "./OurServices.vue?vue&type=template&id=115d468e"
import script from "./OurServices.vue?vue&type=script&lang=js"
export * from "./OurServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__